export default {
  title: 'ExpertOrder',
  form: {
    api_key: {
      label: 'API-sleutel',
    },
  },
  buttons: {
    save: 'Opslaan',
  },
  toasts: {
    error: 'Wijzigingen opslaan mislukt',
    success: 'Wijzigingen zijn opgeslagen',
  },
  connected: {
    title: 'ExpertOrder is verbonden',
    description: 'Deze integratie is ingesteld.',
  },
};
